/** Relay-owned time remains in its source domain. These in-memory receipt
 * bounds survive object copies, not storage/reloads; no source time is rewritten. */
export interface UsTimeEvidence {
  serverMs: number;
  receivedWallMs: number;
  receivedMonoMs: number;
  roundTripMs: number;
}
export function usRequestStamp(clock: () => number = Date.now) {
  return { wallMs: clock(), monoMs: performance.now() };
}
export function captureUsTime(serverMs: number, started: ReturnType<typeof usRequestStamp>, clock: () => number = Date.now): UsTimeEvidence {
  const received = usRequestStamp(clock);
  return { serverMs, receivedWallMs: received.wallMs, receivedMonoMs: received.monoMs,
    roundTripMs: Math.max(0, received.wallMs - started.wallMs, received.monoMs - started.monoMs) };
}
/** Full request/body RTT is conservative transport uncertainty. Constant skew
 * cancels; backward wall steps cannot extend life, forward steps expire early,
 * and advancing wall time covers a performance clock paused during sleep.
 * Missing evidence is only for legacy in-memory callers, never a parsed reply. */
export function usEvidenceNow(evidence: UsTimeEvidence | undefined, wallNow: number): number {
  if (!evidence) return wallNow;
  const mono = performance.now();
  if (![evidence.serverMs, evidence.receivedWallMs, evidence.receivedMonoMs, evidence.roundTripMs, wallNow, mono].every(Number.isFinite)
    || evidence.serverMs <= 0 || evidence.roundTripMs < 0 || mono < evidence.receivedMonoMs) return Infinity;
  return evidence.serverMs + evidence.roundTripMs + Math.max(0, wallNow - evidence.receivedWallMs, mono - evidence.receivedMonoMs);
}
